import React, { useMemo, useState, useEffect } from 'react';
import Modal from 'react-modal';
import './VehiclePerformanceOverview.css';
import VehicleTable from './VehicleTable';
import IssuesOverview from './IssuesOverview';

// Set the app element for the modal
Modal.setAppElement('#root');

const VehiclePerformanceOverview = ({ data, columns }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [sortedData, setSortedData] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: 'vehicle_name', direction: 'asc' });

    useEffect(() => {
        if (data.length > 0 && sortConfig.key) {
            const sorted = [...data].sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
            setSortedData(sorted);
        }
    }, [data, sortConfig]);

    const rowsToShow = 5;
    const tableColumns = useMemo(() => columns, [columns]);
    const tableData = useMemo(() => sortedData.slice(0, rowsToShow), [sortedData]);

    const expandedColumns = useMemo(() => [
        ...columns,
        { Header: 'Min Motor Temp', accessor: 'min_temp' },
        { Header: 'Median Motor Temp', accessor: 'median_temp' },
        { Header: 'Over Current Count', accessor: 'over_current_count' },
        { Header: 'Over Temperature Count', accessor: 'over_temperature_count' },
        { Header: 'Relative Over Current per 1000 km', accessor: 'relative_over_current_per_1000_km' },
        { Header: 'Relative Over Temperature per 1000 km', accessor: 'relative_over_temperature_per_1000_km' },
    ], [columns]);

    const handleExpand = () => {
        setModalIsOpen(true);
    };

    const handleClose = () => {
        setModalIsOpen(false);
    };

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    return (
        <div className="overview-container">
            <div className="overview-section">
                <h3>Vehicle Performance Overview</h3>
                <VehicleTable columns={tableColumns} data={tableData} onSort={handleSort} sortConfig={sortConfig} />
                <button onClick={handleExpand} className="expand-button">Expand</button>
            </div>

            <IssuesOverview data={sortedData} />

            <Modal isOpen={modalIsOpen} onRequestClose={handleClose} className="modal" overlayClassName="modal-overlay">
                <div className="modal-content">
                    <h2>Expanded Vehicle Performance Overview</h2>
                    <div className="table-wrapper">
                        <VehicleTable columns={expandedColumns} data={sortedData} onSort={handleSort} sortConfig={sortConfig} expanded />
                    </div>
                    <div className="close-button-container">
                        <button onClick={handleClose} className="close-button">Close</button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default VehiclePerformanceOverview;
